import type { IBalance } from 'types/IWallet';

const getBalancesToDisplay = (
  whenBelowMd: boolean,
  hideZero: boolean,
  balances: IBalance[]
) =>
  balances
    .filter(value => {
      return hideZero === true ? Boolean(Number(value.balance)) : true;
    })
    .slice(0, whenBelowMd ? Object.keys(balances).length : 4);

export { getBalancesToDisplay };
